import IAddFactory from '../../models/forms/IAddUpdateFactory';

export const initialState: IAddFactory = {
  FactoryId: '',
  FactoryName: '',
  FactoryAddress: '',
  FactoryCity: '',
  FactoryCountry: 'Japan',
  FactoryType: '1',
  IsActive: true,
  UserName: '',
  Email: '',
  Password: '',
  UserType: 2,
  Comment: '',
  AccountStatus: 1,
  UserId: '',
  ConfirmPassword: '',
};
